import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonBackButton,
  IonContent,
  IonButton,
  IonText,
} from '@ionic/react';
import { useRepositories } from '../../infrastructure/http/RepositoryProvider';
import PasswordInput from '../components/PasswordInput';

const ChangePassword: React.FC = () => {
  const history = useHistory();
  const { auth } = useRepositories();
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [saving, setSaving] = useState(false);

  const handleSubmit = async () => {
    setError(null);

    if (!oldPassword || !newPassword || !confirmPassword) {
      setError('Completá los tres campos.');
      return;
    }
    if (newPassword.length < 6) {
      setError('La nueva contraseña debe tener al menos 6 caracteres.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('La nueva contraseña y su repetición no coinciden.');
      return;
    }

    setSaving(true);
    try {
      await auth.changePassword(oldPassword, newPassword);
      history.replace('/app/settings');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'No se pudo cambiar la contraseña.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/app/settings" />
          </IonButtons>
          <IonTitle>Cambiar contraseña</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen className="ion-padding">
        <PasswordInput placeholder="Contraseña actual" value={oldPassword} onValueChange={setOldPassword} />
        <PasswordInput placeholder="Contraseña nueva" value={newPassword} onValueChange={setNewPassword} />
        <PasswordInput
          placeholder="Repetir contraseña nueva"
          value={confirmPassword}
          onValueChange={setConfirmPassword}
        />

        {error && (
          <IonText color="danger">
            <p style={{ fontSize: 13 }}>{error}</p>
          </IonText>
        )}

        <IonButton expand="block" style={{ marginTop: 16 }} onClick={handleSubmit} disabled={saving}>
          {saving ? 'Guardando...' : 'Guardar contraseña'}
        </IonButton>
      </IonContent>
    </IonPage>
  );
};

export default ChangePassword;
